import PropTypes from "prop-types";

export const GenCCType = PropTypes.shape({
  items: PropTypes.arrayOf(
    PropTypes.shape({
      disease: PropTypes.string,
      verdict: PropTypes.string,
      expert_panel: PropTypes.string,
    })
  ),
  version: PropTypes.string,
});
